export default __webpack_public_path__ + "static/media/fridge2-beforeA-480w.19a78f13.webp";